import { Injectable } from "@angular/core";
import { CompanyContext, CompanyContextServiceBase } from "@skylab-shared/core";

@Injectable({providedIn: 'root'})
export class CompanyContextService {
	get companyContext(): CompanyContext {
		return CompanyContextServiceBase.companyContext;
	}

	set companyContext(value: CompanyContext) {
		CompanyContextServiceBase.companyContext = value;
	}
}